<template>
    <div class="item-list">
        <!-- <el-radio-group v-model="check">
            <el-radio v-for="(item, index) in config.list" :key="index" :label="item.name">{{ item.name }}</el-radio>
        </el-radio-group> -->
        <div class="item" :class="{ 'active': check == item.name }" v-for="(item, index) in config.list" :key="index"
            @click="handleCheck(item, index)">{{
            item.name }}</div>
        <!-- 弹出框 -->
        <FormDialog :visible.sync="showDialog" :content="content" />
    </div>
</template>

<script>
import { isEmpty } from '@/utils'
import FormDialog from '@/components/dialog'
export default {
    name: 'FormRadio',
    components: {
        FormDialog
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        check(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.check = value
        }
    },
    data() {
        return {
            check: this.value,
            showDialog: false,
            content: '',
        }
    },
    methods: {
        handleCheck(item, index) {
            if (this.check == item.name) {
                this.check = ''
            } else {
                this.check = item.name
            }
            if (!isEmpty(item.tips)) {
                this.content = item.tips;
                this.showDialog = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.item-list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;

    .item {
        background: #fff;
        border: 1px solid #efefef;
        color: #666;
        padding: 0px 20px;
        margin-bottom: 5px;
        cursor: pointer;
        box-sizing: content-box;
        border-radius: 5px;
        margin-right: 10px;
        font-size: 13px;

        &.active {
            background: #00b4e8;
            color: #FFF;
            border: 1px solid #00b4e8;
        }
    }
}
</style>